import { render, staticRenderFns } from "./Down.vue?vue&type=template&id=1bea268a&scoped=true"
import script from "./Down.vue?vue&type=script&lang=js"
export * from "./Down.vue?vue&type=script&lang=js"
import style0 from "./Down.vue?vue&type=style&index=0&id=1bea268a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea268a",
  null
  
)

export default component.exports